class inforules {
    constructor(
             num,
             rule,
             initials,
             description
    ) {
      this.num = num;
      this.rule = rule;
      this.initials = initials;
      this.rule = rule;
      this.description = description;
     
    }
    static fromJson({ num, regla, sigla, descripcion }) {
      return new inforules(num, regla, sigla, descripcion);
    }
  }
  
  export default inforules;